/** A rejected DSL call. `code` is the backend's stable error code, when it sent one. */
export class DSLExecuteError extends Error {
  constructor(message: string, readonly code?: string) {
    super(message);
    this.name = 'DSLExecuteError';
  }
}
